module.exports = __webpack_public_path__ + "img/item-4.83f61248.png";